import React from 'react'
import './ChartPanel.css'

interface Props {
  title?: string
  subtitle?: string
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

export function ChartPanel({ title, subtitle, children, style }: Props) {
  return (
    <div className="ChartPanel panel-xs" style={style}>
      <div className="ChartPanel-header">
        {title && <h2 className="ChartPanel-title">{title}</h2>}
        {subtitle && <p className="ChartPanel-subtitle">{subtitle}</p>}
      </div>
      {children}
    </div>
  )
}
